import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Modal from "react-responsive-modal";
import { unsubscribe } from "../../api/account";
import "./ReEngagementModal.scss";

const ReEngagementModal = (props) => {
  const { open, onCancel, t, token } = props;
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleUnsubscribe = () => {
    const obj = {
      "token": token,
      "re-engagement": true
    };
    unsubscribe(obj)
      .then(() => {
        setSuccess(true);
      })
      .catch((err) => {
        setError(true);
      });
    
  };

  const handleCancelClick = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const showActionButtons = !success && !error;

  return (
    <Modal
      center
      open={open}
      onClose={handleCancelClick}
      showCloseIcon={false}
      closeOnOverlayClick={false}
      classNames={{ modal: "re-engagement--modal" }}
    >
      {error && <p className="error">{t("unsubscription_failed")}</p>}
      {success && <p className="success">{t("unsubscribed_successfully")}</p>}

      <div className="bottom-section">
        {showActionButtons ? (
          <>
            <button
              className="primary-button"
              type="button"
              onClick={handleUnsubscribe}
            >
              {t("yes_unsubscribe")}
            </button>
            <button
              className="secondary-button"
              type="button"
              onClick={handleCancelClick}
            >
              {t("cancel")}
            </button>
          </>
        ) : (
          <button
            className="secondary-button"
            type="button"
            onClick={handleCancelClick}
          >
            {t("ok_close")}
          </button>
        )}
      </div>
    </Modal>
  );
};

export default withTranslation()(ReEngagementModal);
